import { styled } from '@/styles/stitches.config';

type TermsOfUseEnProps = {
  title: string;
};

const Section = styled('section', {
  marginBlock: '$8',
});

const H1 = styled('h1', {
  color: '$white',
  marginBlockEnd: '$8',
});

const H2 = styled('h2', {
  color: '$white',
  fontWeight: '$normal',
  fontSize: '$3',
});

const StyledA = styled('a', {
  color: '$white',
});

type AProps = {
  href: string;
  children: React.ReactNode;
};

const A = (props: AProps) => {
  return (
    <StyledA href={props.href} rel="noopener noreferrer" target={'_blank'}>
      {props.children}
    </StyledA>
  );
};

export function TermsOfUseAr(props: TermsOfUseEnProps) {
  const { title } = props;

  return (
    <>
      <H1>{title}</H1>

      <Section>
        <H2>اتفاقية المستخدم</H2>
        <p>
          يتضمن الموقع الإلكتروني لمشروع الطفولة المتغيرة مواد تتعلق بتفويض منظمة الأمم المتحدة
          للطفولة (اليونيسف) ومهامها. وبالتحديد، يعرض الموقع نتائج استطلاع عالمي أجرته اليونيسف مع
          شركائها. وموضوع الاستطلاع هو الطفولة في القرن الحادي والعشرين. تشمل المواد المتاحة، على
          سبيل المثال، بيانات ورسوم بيانية وتوضيحية ومقاطع فيديو ومقالات وافتتاحيات صحف. وهذه المواد
          تهدف إلى زيادة معرفتنا وفهمنا لمواضيع معينة. محتويات الموقع للاستخدام الشخصي فقط وليست
          للاستخدام التجاري.
        </p>
        <p>
          يرجى قراءة شروط الاستخدام التالية بعناية. فهذه الشروط بمثابة اتفاقية بينك وبين اليونيسف.
          ومواصلة استخدامك لهذا الموقع هو إقرار منك بأنك قرأت وفهمت وقبلت الشروط والأحكام الواردة
          أدناه. إذا كنت لا توافق على أي من هذه الشروط والأحكام، يرجى عدم استخدام هذا الموقع.
        </p>
        <p>
          تخضع شروط الاستخدام هذه للتغيير دون إشعار، لذا يرجى مراجعة هذه الصفحة لمعرفة أي تحديثات.
          يظهر تاريخ أحدث المراجعات في أسفل هذه الصفحة. إذا واصلت استخدام هذا الموقع، فهذا يعني أنك
          تقبل أي تغييرات أو مراجعات لشروط الاستخدام.
        </p>
        <p>
          وبموجب شروط الاستخدام هذه، فإن كلمات مثل "نحن" أو "لنا" أو ضمير "نا" الدالة على الجماعة
          تشير إلى اليونيسف. في حين تشير كلمات "أنت" و"لك" و"المستخدم" وضمير "ك" المخاطب إلى متصفح
          الموقع، فرداً كان أم مؤسسة.
        </p>
      </Section>

      <Section>
        <H2>محتوى الموقع وقواعد الاستخدام</H2>
        <p>
          الموقع مفتوح للعموم ويرحب بالمستخدمين من جميع بلدان العالم. تهدف اليونيسف إلى إيجاد بيئة
          على موقع مشروع الطفولة المتغيرة يشعر الجميع فيها بالراحة، بغض النظر عن الجنسية أو الجنس أو
          الخلفية الثقافية أو الدين أو الميول الجنسية أو المعتقدات السياسية.
        </p>
        <p>
          وموافقتك على استخدام هذا الموقع محددة بالأغراض المشروعة فقط، وبطريقة لا تنتهك حقوق الموقع
          أو تقيد أو تمنع استخدامه والتمتع به من قبل أي طرف ثالث.
        </p>
        <p>
          تحتفظ اليونيسف بجميع حقوق الملكية في برمجيات هذا الموقع وتصميمه ووظائفه وهندسته وأي برامج
          أو مواد دعم أو محتوى يقدمها (يُشار إليها إجمالاً بـ "حقوق الملكية الفكرية للموقع
          الإلكتروني لمشروع الطفولة المتغيرة"). وباستثناء الحقوق الممنوحة للمستخدم صراحة بموجب شروط
          الاستخدام هذه، لا يمنح المستخدم أياً من حقوق الملكية الفكرية المذكورة. فإذا رغبت باستخدام
          "حقوق الملكية الفكرية للموقع الإلكتروني لمشروع الطفولة المتغيرة" بطريقة لا تسمح بها هذه
          الشروط، عليك أولاً الاتصال مع فريق الموقع الإلكتروني للمشروع والحصول على إذن خطي.
        </p>
        <p>
          وما لم يُذكر صراحة، فإن جميع المواد التي تنشرها اليونيسف على هذا الموقع مرخصة بموجب رخصة
          المشاع الإبداعي "Creative Commons Attribution-Noncommercial-No Derivatives 4.0 Unported".
          وهذه الرخصة تسمح لك وللآخرين بنسخ وإعادة توزيع محتوى الموقع، ولكن لا يُسمح لك أو للآخرين
          بتعديل أو تحويل هذا المحتوى أو استخدامه لأغراض تجارية. وتقضي الرخصة بأن تنسب أي مادة
          تستخدمها إلى المؤلف الأصلي. وعند استخدام <strong>أي مادة من مواد الموقع</strong>، يرجى
          استخدام الإسناد التالي: "دراسة استطلاعية من إعداد اليونيسيف ومؤسسة غالوب. انظر
          ChangingChildhood.unicef.org. إذا كان لديك أي سؤال، لا تتردد في زيارة{' '}
          <A href="https://creativecommons.org/faq/">صفحة الأسئلة الشائعة حول المشاع الإبداعي</A>،
          حيث ستجد معلومات إضافية".
        </p>
        <p>
          يرجى ملاحظة أن هذا الموقع وأي مواد داعمه له قد تحتوي على صور وتسجيلات صوتية ومقاطع فيديو
          تحمل علامات تجارية لأطراف أخرى. ولا يوجد في شروط الاستخدام هذه أو في رخصة المشاع الإبداعي
          ما يحد من أو يقلل حقوق الملكية الفكرية الكاملة لهذه الأطراف. ولا يجوز لك استخدام هذه
          المواد لوسم أو ترويج أو اعتماد أي منتج أو خدمة. وأنت وحدك المسؤول عن أي انتهاك لحقوق
          الملكية الفكرية لأي طرف ثالث جراء إساءة استخدامك لهذه المواد.
        </p>
        <p>
          وأنت، باستخدامك هذا الموقع، توافق على الامتثال لجميع القوانين واللوائح السارية في بلدك.{' '}
        </p>

        <p>
          جميع الأسماء والشعارات العائدة لمشروع الطفولة المتغيرة واليونيسيف هي ملكية حصرية
          لليونيسيف. وهي محمية بموجب القوانين الدولية والوطنية. ويحظر أي استخدام غير قانوني لها. ولا
          يجوز نسخها أو إعادة إنتاجها بأي شكل من الأشكال دون إذن خطي مسبق من اليونيسف. يجب إرسال
          طلبات الحصول على إذن إلى{' '}
          <A href="mailto:nyhqdoc.permit@unicef.org">nyhqdoc.permit@unicef.org</A>. جميع العلامات
          التجارية وعلامات الخدمة والشعارات الأخرى المستخدمة في هذا الموقع، مع الإسناد أو بدونه، هي
          علامات تجارية أو علامات خدمة أو شعارات مملوكة لأصحابها.{' '}
        </p>
        <p>
          تحتفظ اليونيسف بالحق في طلب جميع سبل الانتصاف المتاحة بموجب القانون لأي انتهاك لشروط
          الاستخدام هذه، بما في ذلك أي انتهاك لحقوق اليونيسف في اسم اليونيسف وشعارها وحقوقها بملكية
          المعلومات والأعمال الفنية والنصوص ومقاطع الفيديو والتسجيلات الصوتية والصور أو أي محتوى آخر
          منشور على هذا الموقع.
        </p>
      </Section>

      <Section>
        <H2>الخصوصية وملفات الارتباط وإفشاء المعلومات</H2>
        <p>
          خصوصيتك مهمة بالنسبة لنا. يرجى مراجعة{' '}
          <A href="https://www.unicef.org/legal#privacy-policy">سياسة الخصوصية</A> لدينا والتي تتضمن
          معلومات عن ماهية المعلومات محدودة الاستخدام وطرق اليونيسف في جمعها تخزينها واستخدامها.
          يرجى أيضاً الانتباه إلى أن مواصلة تصفح هذا الموقع تعني أنك قد قرأت{' '}
          <A href="https://www.unicef.org/legal#privacy-policy">سياسة الخصوصية</A> لدينا ووافقت
          عليها.
        </p>
        <p>
          تستخدم اليونيسف ملفات ارتباط على هذا الموقع لتتبع استخدامه. يرجى مراجعة{' '}
          <A href="https://www.unicef.org/legal#unicef-cookies-policy">
            سياسة ملفات تعريف الارتباط لدى اليونيسف
          </A>{' '}
          لمعرفة تفاصيل استخدام هذه الملفات.
        </p>
        <p>
          اليونيسف ملتزمة بإتاحة المعلومات عن برامجها وعملياتها للعموم. يرجى مراجعة{' '}
          <A href="https://www.unicef.org/legal#information-disclosure-policy">
            سياسة الإفصاح عن المعلومات لدى اليونيسف
          </A>{' '}
          لمعرفة التفاصيل.
        </p>
      </Section>

      <Section>
        <H2>روابط إلى مواقع أخرى</H2>
        <p>
          قد يتضمن الموقع روابط إلى مواقع أخرى لا تخضع لإدارة اليونيسف. وتقدمها اليونيسف لتسهيل
          عملية التصفح لا غير، وبالتالي فإن ذكر أي مواقع إلكتروني أو منتجات أو خدمات عائدة لجهات
          خارجية لا يعني موافقة أو اليونيسف عليها أو تزكيتها لها. فإذا قررت زيارة أي من هذه المواقع
          أو التطبيقات، فأنت تفعل ذلك على مسؤوليتك الخاصة. ولا تتحمل اليونيسف أي مسؤولية أو التزام
          حيال تصفح هذه المواقع، بما في ذلك، على سبيل المثال، المسؤولية أو المساءلة عن دقة أو
          موثوقية أي معلومات أو بيانات أو آراء أو نصائح أو بيانات تنشرها تلك المواقع.
        </p>
      </Section>

      <Section>
        <H2>تنويه</H2>
        <p>
          جميع المواد التي تقدمها اليونيسيف على هذا الموقع تنشر تحت مسمى "كما هي". وهذا يعني أننا لا
          نضمن دقة أي من مواد هذا الموقع ولا خلوها التام من الأخطاء.{' '}
        </p>
        <p>
          ولا تتحمل الأمم المتحدة واليونيسيف أي التزام أو مسؤولية تنشأ عن استخدام هذا الموقع أو
          محتواه. ولا تتحمل الأمم المتحدة، بما فيها اليونيسف ومسؤولوها وموظفوها ومستشاروها ووكلاؤها
          والمتعاقدون معها، مسؤولية أي عواقب مالية أو غيرها من العواقب المترتبة على استخدام هذا
          الموقع ومحتوياته، كالاستخدام غير المناسب أو غير اللائق أو الاحتيالي لهذه المحتويات.
        </p>
        <p>
          لا تتحمل اليونيسف أي مسؤولية أو التزام حيال سلوك أي مستخدم فيما يتعلق بهذا الموقع، أو عن
          أي مادة يرفعها المستخدمون وينقلها هذا الموقع، بما في ذلك، على سبيل المثال، المسؤولية أو
          المساءلة عن دقة أو موثوقية أي معلومات أو بيانات أو آراء أو نصائح أو تصريحات تتضمنها هذه
          المواد.
        </p>
        <p>
          لا تقدم اليونيسف أي كفالة بأن تكون الخصائص الواردة في محتوى أو موارد هذا الموقع متواصلة
          بلا انقطاع أو خالية من الأخطاء، أو أنه سيتم تصحيح العيوب، أو أن هذا الموقع أو الخادم
          المسؤول عنه خالٍ من الفيروسات أو يمثل التشغيل الكامل للمحتوى أو الموارد أو دقتها أو
          مصداقيتها. لا تمنح اليونيسف أي تعهدات أو ضمانات من أي نوع بخصوص هذا الموقع، بما في ذلك
          المسؤولية عن أي إصابة بفيروس أو أي تلوث آخر أو أي شيء له خصائص تخريبية.
        </p>
        <p>
          أنت توافق، وعلى نفقتك الخاصة، على تعويض اليونيسف ومسؤوليها وموظفيها ومستشاريها ووكلائها ضد
          أي مطالبات (كالتكاليف والنفقات وغيرها) من قبل أي طرف ثالث تتعلق أو تنشئ عن (أ) استخدامك أو
          محاولتك استخدام هذا الموقع أو موارده أو خدماته بطريقة تنتهك هذه الاتفاقية؛ (ب) انتهاكك لأي
          قانون أو حقوق تعود لأي طرف ثالث؛ (ج) أي محتوى تقوم بنشره أو إتاحته بطريقة أخرى على هذا
          الموقع أو من خلال أي خدمة، بما في ذلك، على سبيل المثال، أي ادعاء بانتهاك أو اختلاس حقوق
          الملكية الفكرية أو حقوق الملكية الأخرى.
        </p>
        <p>
          باستثناء ما تنص عليه شروط الاستخدام هذه صراحة، لا تقدم اليونيسف للمستخدم أي تعهد أو أي
          كفالة من أي نوع، صريحة كانت أم ضمنية، بخصوص أي من الخدمات. على سبيل المثال، لا نقدم أي
          التزامات بشأن المحتوى داخل الخدمات أو الوظائف المحددة للخدمات أو مصداقيتها أو توفرها أو
          قدرتها على تلبية احتياجاتك. لا تتحمل اليونيسف هنا أي مسؤولية حيال جميع الكفالات الضمنية
          الخاصة بقابلية أي مما سبق للتسويق أو ملاءمته لغرض معين أو حيال عدم الانتهاك.
        </p>
        <p>
          تجري اليونيسف بشكل دوري إضافات أو تغييرات أو تحسينات أو تحديثات على مواد هذا الموقع دون
          إشعار. لا تتحمل اليونيسف تحت أي ظرف كان أي مسؤولية عن أي خسارة أو ضرر أو مسؤولية أو نفقات
          يُزعم بأنها ترتبت على استخدام هذا الموقع، بما في ذلك، على سبيل المثال لا الحصر، أي خطأ أو
          خلل أو إغفال أو تعطيل أو تأخير في هذا المضمار. يتحمل المستخدم وحده مسؤولية استخدام هذا
          الموقع. لا تتحمل اليونيسف أو الجهات التابعة لها، تحت أي ظرف من الظروف، بما فيه الإهمال على
          سبيل المثال لا الحصر، مسؤولية أي أضرار، حتى لو تم إخطار اليونيسف سلفاً بإمكانية حدوثها.
          تأكد من استخدام المحتوى على هذا الموقع بعناية ومسؤولية.
        </p>
        <p>
          أنت توافق على أنك المسؤول الوحيد عن أي مشكلات قد تواجهها نتيجة استخدامك لهذا الموقع. لا
          تتحمل اليونيسف، تحت أي ظرف كان، مسؤولية أي أضرار أو إصابات قد تحصل لك نتيجة استخدامك لهذا
          الموقع.
        </p>
        <p>
          ذكر أسماء شركات أو منتجات معينة على هذا الموقع لا يعني أي نية بانتهاك حقوق الملكية، ولا
          ينبغي تفسيره على أنه تأييد أو توصية من جانب اليونيسف لتلك الشركات أو المنتجات.
        </p>
        <p>
          إن استخدام أسماء أو خرائط لبلدان أو أقاليم معينة على هذا الموقع لا يعكس موقف اليونيسف من
          الوضع القانوني لهذه البلدان أو الأقاليم، أو لسلطاتها ومؤسساتها أو ترسيم حدودها.
        </p>
      </Section>

      <Section>
        <H2>الامتيازات والحصانات</H2>
        <p>
          لا شيء في شروط الاستخدام هذه أو يتعلق بها يمكن أن يعتبر تنازلاً، صريحاً أو ضمنياً، عن أي
          من امتيازات وحصانات اليونيسيف، تحت اتفاقية امتيازات الأمم المتحدة وحصاناتها لعام 1946، أو
          غير ذلك.
        </p>
      </Section>

      <Section>
        <H2>معلومات الاتصال</H2>
        <p>
          إذا كان لديك أية أسئلة عن هذا الموقع، يرجى استخدام{' '}
          <A href="https://www.unicef.org/about/contact_contactusform.php">نموذج الملاحظات</A>.
        </p>
      </Section>

      <footer>
        <p>تاريخ آخر تحديث: 13 أيلول/سبتمبر 2021</p>
      </footer>
    </>
  );
}
